import React from 'react';
import { modelClass } from '/imports/api/buyCounters';
import { ModelFormPage } from '/imports/ui/ModelFormPage';

export const BuyCounterPage = () => (
  <ModelFormPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    formSpec={() => [[{ field: 'cardId', label: 'Card ID' }], [{ field: 'num', label: 'Net Sales' }], [{ field: 'stamp', label: 'Last Updated' }]]}
  />
);
